<template>
  <div
    v-click-outside="closeMenu"
    class="select_number-symbol"
  >
    <div class="select__icon">
      <svg
        :class="iconElemCss"
        width="12"
        height="12"
        viewBox="0 0 8 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="menuIsOpen = !menuIsOpen"
      >
        <path
          d="M3.96368 0.5H4.17502L8 3.9139L7.4024 4.5L4 1.50055L0.5976 4.5L0 3.9139L3.82498 0.5H3.96368Z"
          fill="black"
        />
      </svg>
    </div>
    <div v-show="menuIsOpen" class="select__menu">
      <div class="menu__wrapper">
        <ul class="wrapper__list blue-scroll">
          <li
            v-for="item, index in list"
            :key="index"
            :class="getListItemCss(item)"
            @click="updateValue(item)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    dropdownMinWidth: {
      type: String,
      default: '38px',
    },
    list: {
      type: Array,
      default() {
        return ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      },
    },
  },
  emits: ['input', 'change'],
  data() {
    return {
      menuIsOpen: false,
    };
  },
  computed: {
    iconElemCss() {
      return ['icon__elem', {
        'icon__elem_active': this.menuIsOpen,
      }];
    },
  },
  methods: {
    closeMenu() {
      if (this.menuIsOpen) {
        this.menuIsOpen = false;
      }
    },
    getListItemCss(currentValue = '') {
      return ['list__item', {
        'list__item_active': this.value === currentValue,
      }];
    },
    updateValue(value = '') {
      this.menuIsOpen = false;
      const isNewValue = value !== this.value;
      const emittingValue = isNewValue ? value : '*';
      this.$emit('input', emittingValue);
      this.$emit('change', emittingValue);
    },
  },
};
</script>

<style lang="scss">
.select_number-symbol .select__icon {
  display: flex;
  justify-content: center;
}
.select_number-symbol .icon__elem {
  transform: rotate(180deg);
  transition: transform 0.3s;
  cursor: pointer;
}
.select_number-symbol .icon__elem_active {
  transform: rotate(0);
}
.select_number-symbol .select__menu {
  display: flex;
  justify-content: center;
  z-index: 2;
  position: relative;
}
.select_number-symbol .menu__wrapper {
  background-color: #fff;
  border: 1px solid #BFC1C1;
  margin-top: 14px;
  padding: 0 6px;
  min-width: v-bind('dropdownMinWidth');
}
.select_number-symbol .wrapper__list {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 9.5px;
  margin: 10px 0;
  list-style-type: none;
  font-family: 'Montserrat';
  font-size: 25px;
  font-weight: 400;
  line-height: 30px;
  max-height: 512px;
  overflow-y: auto;
  overflow-x: hidden;
}
.select_number-symbol .list__item {
  margin: 0;
  padding: 0;
  transition: opacity 0.3s;
}
.select_number-symbol .list__item:before {
  content: '';
  margin: 0;
}
.select_number-symbol .list__item:hover {
  cursor: pointer;
  opacity: 0.5;
}
.select_number-symbol .list__item:not(:first-child) {
  margin-top: 12px;
}
.select_number-symbol .list__item_active {
  color: #365EDC;
  font-weight: 600;
}
@media (max-width: 767px) {
  .select_number-symbol .wrapper__list {
    max-height: 220px;
  }
}
</style>
